export default __webpack_public_path__ + "static/industry_experts_join_img1-75bac21e903f4233a56018cab016a70d.svg";